/*!
 * AUIGrid 3.0.12 License
 * Product ID : AUIGrid-EN-90035-371965-210329
 * Authorized Domain(or IP) : app.imtrial.com
 * www.auisoft.net
 */
/* eslint-disable */
AUIGridLicense = "eyJjdCI6Ik9TRUNpSmx2RTY4dVgwYU5vcDRRTWdWZ0dBbHY2dFhMZ0JpK1BHRmNmM0RWRkY3YjVaaVZ2OUZzM0t6OTA3T24rRDhnZENBaUNFOW9WUHBcL3FReU5mUzNkT0U2WndBWWMzaDdPWXdyN3l2ME9pM2VNbm9YcnF0Z3pzbzFNN240OENcL1wvMkRhU1F5SUFBK2orWURVYmNZUT09IiwiaXYiOiI4NTMwYjQ3Njg5ODU2ODkyMDUzNTQ3NThhNDBkMzg4ZSIsInMiOiIzMzQ2MTRkZTliMGE3NDJkIn0=";